import React from 'react';
import { FeatureVisualId } from '../features';
import SiteVisual from './SiteVisual';
import GuestsVisual from './GuestsVisual';
import RsvpVisual from './RsvpVisual';
import EventsVisual from './EventsVisual';
import SeatingVisual from './SeatingVisual';
import BudgetVisual from './BudgetVisual';
import RetroVisual from './RetroVisual';
import DashboardVisual from './DashboardVisual';
import DayplanVisual from './DayplanVisual';
import '../../../../styles/marketing-features.css';

const VISUALS: Record<FeatureVisualId, React.FC> = {
  site: SiteVisual,
  guests: GuestsVisual,
  rsvp: RsvpVisual,
  events: EventsVisual,
  seating: SeatingVisual,
  budget: BudgetVisual,
  retro: RetroVisual,
  dashboard: DashboardVisual,
  dayplan: DayplanVisual,
};

// Petite animation en boucle en tête de chaque carte de fonctionnalité.
// Purement décorative : masquée aux lecteurs d'écran, figée si l'utilisateur
// a demandé de réduire les animations.
const FeatureVisual: React.FC<{ id: FeatureVisualId }> = ({ id }) => {
  const Visual = VISUALS[id];
  return (
    <div className="mk-fv" aria-hidden="true">
      <Visual />
    </div>
  );
};

export default FeatureVisual;
